<template>
  <Headers> </Headers>
  <div :class="[deviceType, 'progressContainer']">
    <div :class="[deviceType, 'landingContainer']">
      <div :class="[deviceType, 'imgContainer']">
        <img
          :class="[deviceType, 'imgDraft']"
          src="../../../../assets/icons/noDraft.svg"
        />
      </div>
      <h1>{{ t("ccOnBoarding.resume.noDraftTitle") }}</h1>
      <p>{{ t("ccOnBoarding.resume.noDraftDesc") }}</p>

      <div :class="[deviceType, 'buttoncontainer']">
        <button
          :class="[deviceType, 'right-button']"
          @click="startNewApplication()"
        >
          {{ t("ccOnBoarding.resume.buttonNew") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import i18n from "@/plugin/i18n";
import { inject } from "vue";
import Headers from "./../components/Headers.vue";
import { useRouter } from "vue-router";

const deviceType = inject("deviceType");
const { t } = i18n.global;

const prop = defineProps({
  type: {
    type: String,
  },
  cardId: {
    type: String,
  },
  resumeInfo: {
    type: Object,
    required: true,
  },
  ccFormValue: {
    type: Object,
    required: true,
  },
});

const router = useRouter();
const emit = defineEmits(["jumpStep", "submit", "newApplication"]);

const startNewApplication = () => {
  if (prop.type == "FINPLUS") {
    const requestModel = {
      idType: prop.resumeInfo.idType,
      idNo: prop.resumeInfo.idNo,
      mobileCountryCode: prop.resumeInfo.countryCode,
      mobileNumber: prop.resumeInfo.mobileNo,
      emailAddress: prop.resumeInfo.email,
    };
    MasterService.searchCIF(requestModel)
      .then((res) => {
        if (res.status == 200) {
          if (res.data.responseModel.cifVerify == "true") {
            // existing customer
            prop.ccFormValue.cifNo = res.data.responseModel.cifNo;
            // emit("jumpStep", 1, "", 101);
            emit("submit");
          } else {
            // non-existing customer
            emit("newApplication");
            emit("jumpStep", 1, "", 4);
          }
        }
      })
      .catch((e) => {
        emit("newApplication");
        emit("jumpStep", 1, "", 4);
      });
  } else {
    emit("newApplication");
    if ((prop.cardId == "NA" || prop.cardId == "") && prop.type != "BIO") {
      emit("jumpStep", 0, "", 4);
    } else emit("jumpStep", 1, "", 4);
  }
};
</script>

<style scoped>
h1 {
  color: var(--Primary-Active, #ac2887);
  text-align: center;

  /* H2 */
  font-family: Outfit;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 26px */
}

p {
  color: var(--black-medium-54, rgba(0, 0, 0, 0.54));
  text-align: center;

  /* Subtitle 1 (Medium) */
  font-family: Outfit;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 20.8px */
}

.imgContainer {
  display: flex;
}

.imgDraft {
  margin: auto;
  width: 100%;
  max-width: 338px;
}

.buttoncontainer {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 24px;
}

.buttoncontainer:is(.Mobile) {
  padding: 0;
}

.right-button {
  height: 40px;
  padding: 8px 60px;
  border-radius: 24px;
  border: none;
  background-image: var(
    --gradient-set-active,
    linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
  );
  font-size: 14px;
  font-weight: 600;
  color: #fff;
}

.landingContainer:is(.Mobile) {
  padding: 20px 20px 0 20px;
}

.imgDraft:is(.Mobile) {
  width: 70%;
}
</style>
